import {Charity} from "../../model/EstateFlowchartTypes";
import {ValidationError, ValidationErrorType} from "../ValidationTypes";
import {isValid} from "../ValidationUtils";

const hasText = (value?: string): boolean => (value ?? "").trim() !== "";

const parseLegacyCharityNames = (charityName?: string): string[] =>
    (charityName ?? "")
        .trim()
        .replace(/^charity:\s*/i, "")
        .split(",")
        .map((name) => name.trim())
        .filter(hasText);

const hasAnyBeneficiaryName = (charity: Charity): boolean => {
    if (charity.charityBeneficiaries?.some((beneficiary) => hasText(beneficiary.name))) {
        return true;
    }

    return parseLegacyCharityNames(charity.name).length > 0;
};

export const validateCharities = (charities: Charity[], enableEstateFlowchartMVPRelease: boolean): ValidationError[] => {
    let validationErrors = [] as ValidationError[];

    if (charities && charities.length > 0) {
        charities.forEach((charity) => {

            if (enableEstateFlowchartMVPRelease) {
                if (!hasAnyBeneficiaryName(charity)) {
                    validationErrors.push({
                        type: ValidationErrorType.REQUIRED_FIELDS,
                        property: 'charityBeneficiaries',
                        parent: charity.name,
                        error: 'Beneficiary is required.'
                    });
                }
            } else {
                if (!isValid(charity.name)) {
                    validationErrors.push({
                        type: ValidationErrorType.REQUIRED_FIELDS,
                        property: 'name',
                        parent: charity.name,
                        error: 'Charity name is required.'
                    });
                }
            }
        });
    }

    return validationErrors;
}